import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/renovation/component_wrapper/editors/check_box.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import Editor from "./editor";
var CheckBox = /*#__PURE__*/function (_Editor) {
  _inherits(CheckBox, _Editor);
  function CheckBox() {
    _classCallCheck(this, CheckBox);
    return _possibleConstructorReturn(this, _getPrototypeOf(CheckBox).apply(this, arguments));
  }
  _createClass(CheckBox, [{
    key: "_useTemplates",
    value: function _useTemplates() {
      return false;
    }
  }, {
    key: "_isFocused",
    value: function _isFocused() {
      var focusTarget = this.$element()[0];
      return focusTarget.classList.contains("dx-state-focused");
    }
  }, {
    key: "getSupportedKeyNames",
    value: function getSupportedKeyNames() {
      return ["space"];
    }
  }, {
    key: "getProps",
    value: function getProps() {
      var props = _get(_getPrototypeOf(CheckBox.prototype), "getProps", this).call(this);
      if (null !== props.value) {
        props.value = Boolean(props.value);
      }
      return props;
    }
  }]);
  return CheckBox;
}(Editor);
export { CheckBox as default };